import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CButtonGroupItem } from '.';
import CError from '@/components/shared/CError.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CButtonGroup',
  props: {
    items: null,
    value: null,
    type: { default: 'checkbox' },
    size: { default: 'md' },
    disabled: { type: Boolean },
    separate: { type: Boolean },
    selectedIcon: { default: 'fa-solid fa-check' },
    initialIcon: { default: 'fa-solid fa-plus' },
    pill: { type: Boolean },
    noIcon: { type: Boolean },
    error: { type: Boolean },
    errorMsg: null,
    wide: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { items: CButtonGroupItem[], value?: unknown, type: 'radio' | 'checkbox', size: 'sm' | 'md' | 'lg', disabled?: boolean, separate?: boolean, selectedIcon: string, initialIcon: string, pill?: boolean, noIcon?: boolean, error?: boolean, errorMsg?: string, wide?: boolean };





const selectedValues = computed({
    get() {
        return props.value;
    },
    set(value: unknown) {
        emit('input', value);
    }
});

const isItemActive = (item: CButtonGroupItem) => {
    return Array.isArray(selectedValues.value)
        ? selectedValues.value.includes(item.value)
        : selectedValues.value === item.value;
};

const itemIcon = (item: CButtonGroupItem) => {
    if (
        selectedValues.value === item.value ||
        (Array.isArray(selectedValues.value) && selectedValues.value.includes(item.value))
    ) {
        return item.selectedIcon || props.selectedIcon;
    }

    return item.initialIcon || props.initialIcon;
};

return { __sfc: true,props, emit, selectedValues, isItemActive, itemIcon, CError }
}

})